Promise.all([
  fetch('/wp-json/wf/v1/stocks').then((response) => response.json()),
  new Promise((resolve, reject) => {
    document.addEventListener('DOMContentLoaded', resolve);
  })
]).then((resps) => {
  let data = resps[0];
  for (let key in data) {
    let display = data[key];
    switch (key) {
      case 'date':
        display = (new Date(display)).toLocaleDateString('en-US');
        break;
      case 'volume':
        display = display.toLocaleString();
        break;
      default:
        display = display.toFixed(2).toLocaleString();
        break;
    }

    document.querySelectorAll(`.fbhs-stock_${key}`).forEach((elem) => {
      elem.innerHTML = display;
    })
  }
})
